import React from 'react';
import { useLocation } from 'react-router-dom';

/** Pages that render full-screen on their own, without the site navigation and footer. */
const FOCUSED_ROUTES = ['/request-demo'];
type SiteChromeProps = {
  children: React.ReactNode;
};
export function SiteChrome({
  children
}: SiteChromeProps) {
  const {
    pathname
  } = useLocation();
  if (FOCUSED_ROUTES.includes(pathname)) return null;
  return <>{children}</>;
}